/* ============================================================
   Coin PDP – Lieferdatum  (window.CoinDelivery)
   EINZIGE Quelle für alle Lieferdatum-Anzeigen (Hero, Sticky,
   Final-CTA). Rein CLIENT-SEITIG, weil Liquid gecacht wird.
   Zeitzone fest Europe/Berlin (Intl, nicht ungeprüfte Gerätezeit).

   Regeln (Runde 38):
   - Werktag = Mo-Fr und kein bundesweiter Feiertag (Neujahr,
     Karfreitag, Ostermontag, 1. Mai, Himmelfahrt, Pfingstmontag,
     3. Oktober, 25./26. Dezember)
   - Werktag vor Cutoff  -> Versandtag = heute
   - Werktag ab Cutoff   -> Versandtag = nächster Werktag
   - kein Werktag        -> Versandtag = nächster Werktag
   - Lieferfenster = Versandtag + Laufzeit in Werktagen nach Land
     (localization.country, window.NS_TEXTE.lieferLand):
     Deutschland 1-2, sonst 3-4. Die Section-Settings dhl_min/dhl_max
     zaehlen seitdem nicht mehr.
   - Datumsformat nach Seitensprache: de "Do, 10. September",
     en "Thu, 10 September".
   - Countdown an Werktagen vor Cutoff (1x/Min aktualisiert),
     abschaltbar; Cutoff-Uhrzeit als Config.
   No-JS: das Element behält seinen server-gerenderten Fallbacktext.

   Registrierung reihenfolge-unabhängig via window.__coinDeliveryQueue.

   Vorlagen-Token: {lead} {range} {DATUM_VON} {DATUM_BIS}
   Seit Runde 38: {DAUER} ("2 Std. 5 Min." / "1 hr 5 min", ohne
   Stunden unter einer Stunde) und {VERSAND_TAG} ("morgen" /
   "Mo, 26. Oktober"; en "tomorrow" / "on Mon, 26 October").
   {h} und {m} bleiben fuer die alten Vorlagen.
   und – seit der V2-PDP – {DATUM_VON_TAG} / {DATUM_BIS_TAG}
   ("Do, 10. September"). compute() liefert zusätzlich restMin,
   die Restminuten bis zum Cutoff, damit eine Anzeige formatieren
   kann, ohne selbst zu rechnen. Die Berechnung selbst bleibt hier
   und nur hier.
   ============================================================ */
(function () {
  // Zweites Laden auf derselben Seite (z. B. Hero + Cart-Drawer): nur die
  // Warteschlange an die BESTEHENDE API uebergeben. Nicht drain() nehmen –
  // dessen render() liefe in dieser Instanz gegen ein noch leeres cfg.
  if (window.CoinDelivery) {
    var q0 = window.__coinDeliveryQueue;
    if (q0 && q0.length) {
      while (q0.length) { try { q0.shift()(window.CoinDelivery); } catch (e) {} }
    }
    return;
  }

  // Monats- und Wochentagsnamen kommen aus dem Locale
  // (snippets/ns-assets setzt window.NS_TEXTE aus locales/*.json,
  // Keys ns.liefer.monate und ns.liefer.tage, je eine Liste mit
  // Komma getrennt). Faellt das aus, bleiben die deutschen Namen
  // als Notnagel stehen - eine leere Zustellzeile waere schlimmer
  // als eine deutsche.
  //
  // Die BERECHNUNG bleibt davon unberuehrt: Cutoff 14:00,
  // Europe/Berlin, Werktags-Arithmetik, DHL-Fenster. Hier werden nur
  // Namen eingesetzt.
  function liste(name, notnagel) {
    var w = (window.NS_TEXTE || {})[name];
    if (!w) return notnagel;
    var teile = String(w).split(',').map(function (x) { return x.trim(); })
      .filter(function (x) { return x.length; });
    return teile.length === notnagel.length ? teile : notnagel;
  }
  var DE_MONTHS = liste('lieferMonate',
                  ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni',
                   'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember']);
  // Kurze Wochentage fuer die Zustellzeile der V2-PDP
  // ("Do, 10. September").
  var DE_DAYS = liste('lieferTage', ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa']);

  // Sprache und Land kommen aus layout/theme.liquid (request.locale,
  // localization.country). Ohne Angabe: Deutsch, Deutschland.
  var T = window.NS_TEXTE || {};
  var EN = /^en/i.test(String(T.lieferSprache ||
    (document.documentElement && document.documentElement.getAttribute && document.documentElement.getAttribute('lang')) || 'de'));
  function wort(name, de, en) { return T[name] || (EN ? en : de); }

  var cfg = {
    tz: 'Europe/Berlin',
    cutoffHour: 14, cutoffMin: 0,
    dhlMin: 2, dhlMax: 3,          // nur noch fuer configure-Kompatibilitaet
    land: String(T.lieferLand || 'DE').toUpperCase(),
    countdown: true,
    leadStatic: 'In 24h graviert & versendet',
    countdownTpl: 'Bestelle in den nächsten {h} Std. {m} Min. – heute noch graviert & versendet'
  };

  var els = [];       // {el, tpl}
  var timer = null;

  // Kalenderteile in Europe/Berlin fuer einen Zeitpunkt.
  function berlinParts(date) {
    var f = new Intl.DateTimeFormat('en-GB', {
      timeZone: cfg.tz, year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', hour12: false
    });
    var o = {};
    f.formatToParts(date).forEach(function (p) { o[p.type] = p.value; });
    return { y: +o.year, mo: +o.month, d: +o.day, h: (+o.hour) % 24, mi: +o.minute };
  }

  // Werktags-Arithmetik auf UTC-Kalendertagen (zeitzonenneutral).
  function addDays(d, n) { var x = new Date(d.getTime()); x.setUTCDate(x.getUTCDate() + n); return x; }
  function schluessel(d) { return d.getUTCFullYear() + '-' + (d.getUTCMonth() + 1) + '-' + d.getUTCDate(); }

  // Ostersonntag (gregorianisch, Meeus/Jones/Butcher).
  function ostern(y) {
    var a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4;
    var f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3);
    var h = (19 * a + b - d - g + 15) % 30, i = Math.floor(c / 4), k = c % 4;
    var l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451);
    var monat = Math.floor((h + l - 7 * m + 114) / 31), tag = ((h + l - 7 * m + 114) % 31) + 1;
    return new Date(Date.UTC(y, monat - 1, tag));
  }
  // Bundesweite Feiertage eines Jahres als Set von Schluesseln.
  var feiertagsCache = {};
  function feiertage(y) {
    if (feiertagsCache[y]) return feiertagsCache[y];
    var o = ostern(y), set = {};
    [[0, 1], [4, 1], [9, 3], [11, 25], [11, 26]].forEach(function (md) {
      set[schluessel(new Date(Date.UTC(y, md[0], md[1])))] = 1;
    });
    [-2, 1, 39, 50].forEach(function (n) { set[schluessel(addDays(o, n))] = 1; });
    return (feiertagsCache[y] = set);
  }
  function istWerktag(d) {
    var w = d.getUTCDay();
    return w !== 0 && w !== 6 && !feiertage(d.getUTCFullYear())[schluessel(d)];
  }
  function addBusinessDays(d, n) {
    var x = new Date(d.getTime()), added = 0;
    while (added < n) { x = addDays(x, 1); if (istWerktag(x)) added++; }
    return x;
  }
  function laufzeit() { return cfg.land === 'DE' ? [1, 2] : [3, 4]; }

  // de "Do, 10. September", en "Thu, 10 September".
  function tagMonat(d) { return d.getUTCDate() + (EN ? ' ' : '. ') + DE_MONTHS[d.getUTCMonth()]; }
  function formatWithDay(d) { return DE_DAYS[d.getUTCDay()] + ', ' + tagMonat(d); }

  function formatRange(von, bis) {
    var dv = von.getUTCDate(), db = bis.getUTCDate(), mv = von.getUTCMonth(), mb = bis.getUTCMonth();
    if (EN) {
      if (mv === mb) return dv + '–' + db + ' ' + DE_MONTHS[mb];
      return dv + ' ' + DE_MONTHS[mv] + '–' + db + ' ' + DE_MONTHS[mb];
    }
    if (mv === mb) return dv + '.–' + db + '. ' + DE_MONTHS[mb];
    return dv + '. ' + DE_MONTHS[mv] + '–' + db + '. ' + DE_MONTHS[mb];
  }

  // "2 Std. 5 Min." / "1 hr 5 min"; unter einer Stunde nur Minuten.
  function dauer(min) {
    var h = Math.floor(min / 60), m = min % 60;
    var tStd = h === 1 ? wort('lieferStunde', 'Std.', 'hr') : wort('lieferStunden', 'Std.', 'hrs');
    var tMin = wort('lieferMinuten', 'Min.', 'min');
    return (h > 0 ? h + ' ' + tStd + ' ' : '') + m + ' ' + tMin;
  }

  // Kernberechnung. `now` optional (fuer Tests mockbar).
  function compute(now) {
    var b = berlinParts(now || new Date());
    var today = new Date(Date.UTC(b.y, b.mo - 1, b.d));
    var ship, beforeCutoff = false;
    if (!istWerktag(today)) { ship = addBusinessDays(today, 1); }   // Wochenende, Feiertag
    else {
      var afterCut = (b.h > cfg.cutoffHour) || (b.h === cfg.cutoffHour && b.mi >= cfg.cutoffMin);
      if (afterCut) { ship = addBusinessDays(today, 1); } // naechster Werktag
      else { ship = today; beforeCutoff = true; }
    }
    var lz = laufzeit();
    var von = addBusinessDays(ship, lz[0]);
    var bis = addBusinessDays(ship, lz[1]);
    var morgen = schluessel(ship) === schluessel(addDays(today, 1));
    var versandTag = morgen ? wort('lieferMorgen', 'morgen', 'tomorrow')
      : (EN ? 'on ' : '') + formatWithDay(ship);
    var lead = cfg.leadStatic.replace('{VERSAND_TAG}', versandTag);
    var remMinOut = 0;
    if (beforeCutoff) {
      var remMin = (cfg.cutoffHour * 60 + cfg.cutoffMin) - (b.h * 60 + b.mi);
      if (remMin < 0) remMin = 0;
      remMinOut = remMin;
      if (cfg.countdown) {
        lead = cfg.countdownTpl.replace('{DAUER}', dauer(remMin))
          .replace('{h}', Math.floor(remMin / 60)).replace('{m}', remMin % 60);
      }
    }
    var sameMonth = von.getUTCMonth() === bis.getUTCMonth();
    return {
      range: formatRange(von, bis),
      lead: lead,
      beforeCutoff: beforeCutoff,
      ship: ship,
      von: von, bis: bis,
      vonStr: EN ? (von.getUTCDate() + (sameMonth ? '' : ' ' + DE_MONTHS[von.getUTCMonth()]))
                 : (von.getUTCDate() + '.' + (sameMonth ? '' : ' ' + DE_MONTHS[von.getUTCMonth()])),
      bisStr: tagMonat(bis),
      vonTagStr: formatWithDay(von),
      bisTagStr: formatWithDay(bis),
      versandTag: versandTag,
      // Restminuten bis zum Cutoff, roh. Die Vorlage soll sie
      // formatieren koennen, ohne selbst zu rechnen.
      restMin: remMinOut
    };
  }

  function render() {
    var r = compute();
    els.forEach(function (e) {
      e.el.textContent = (e.tpl || '')
        .replace('{lead}', r.lead)
        .replace('{range}', r.range)
        .replace('{DATUM_VON}', r.vonStr)
        .replace('{DATUM_BIS}', r.bisStr)
        // Neu fuer die V2-PDP: mit Wochentag.
        .replace('{DATUM_VON_TAG}', r.vonTagStr)
        .replace('{DATUM_BIS_TAG}', r.bisTagStr);
    });
    // Countdown-Aktualisierung 1x/Minute (nur wenn aktiv).
    if (!timer && cfg.countdown) { timer = setInterval(render, 60000); }
  }

  var API = {
    configure: function (o) {
      if (!o) return;
      if (o.cutoff) { var p = String(o.cutoff).split(':'); cfg.cutoffHour = +p[0] || 0; cfg.cutoffMin = +p[1] || 0; }
      ['dhlMin', 'dhlMax', 'countdown', 'leadStatic', 'countdownTpl', 'tz'].forEach(function (k) {
        if (o[k] !== undefined && o[k] !== '' && o[k] !== null) cfg[k] = o[k];
      });
      if (o.land) cfg.land = String(o.land).toUpperCase();
      render();
    },
    register: function (el, tpl) { if (!el) return; els.push({ el: el, tpl: tpl }); render(); },
    // Nur fuer Tests: reine Berechnung mit gemocktem `now`.
    _compute: compute,
    _istWerktag: istWerktag
  };

  window.CoinDelivery = API;
  drain();

  function drain() {
    var q = window.__coinDeliveryQueue;
    if (q && q.length) { while (q.length) { try { q.shift()(window.CoinDelivery); } catch (e) {} } }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', render); }
    else { render(); }
  }
})();
